// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3EjQQ","label":"Labeled_label__2cGzF","divider":"Labeled_divider__2bGYx"};